module.exports = __webpack_public_path__ + "static/media/ITC-OfficinaSansITCPro-Book.6a0a8088.woff2";